import api, { adminApiPrefix } from './Api';
import {
  RelatedProductsResponse,
  relatedProductsResponseFromResponse,
} from '../interfaces/RelatedProduct/RelatedProductsResponse';

const relatedProductAdminApiPrefix = `${adminApiPrefix}/related-product`;

export const getRelatedProducts = async (
  productID: number,
): Promise<RelatedProductsResponse> => {
  const response = await api.get(
    `${relatedProductAdminApiPrefix}/${productID}`,
  );

  return relatedProductsResponseFromResponse(response.data ?? {});
};

export const upsertRelatedProducts = async (
  productID: number,
  relatedProductIDs: number[],
): Promise<void> =>
  api.post(`${relatedProductAdminApiPrefix}/${productID}`, {
    related_product_ids: relatedProductIDs,
  });
